import React from 'react';

export function StepSubjectLabel() {
  return (
    <>
      Nová provozovna - <b>Výběr provozovatele</b>
    </>
  );
}
